import {React, useEffect, useState} from 'react'
import { Line } from 'react-chartjs-2';
import numeral from 'numeral'

function LineGraph({caseType}) {

    const [graphData, setGraphData] = useState({})
    let dataa = [];
    let labels = [];
    let lastdatapoint;
    useEffect(async () => {
        await fetch('https://disease.sh/v3/covid-19/historical/all?lastdays=120')
        .then((response) => response.json())
        .then(data => {
            for (const [key, value] of Object.entries(data[caseType])) {
                if(lastdatapoint){
                    // dataa.push({
                    //     x:key,
                    //     y:value
                    // });
                    labels.push(key)
                    dataa.push(value - lastdatapoint)
                }
               lastdatapoint =  value

            }
            console.log(dataa)
            setGraphData({
                labels: labels,
                datasets: [
                  {
                    backgroundColor: 'rgba(75,192,192,1)',
                    borderColor: 'rgba(0,0,0,1)',
                    data: dataa
                  },
                ]
              })
            
        })
      }, [caseType])

    return (
        <div style={{flexGrow:1}}>
            <Line data={graphData}  options={{
              
                legend:{
                  display:false
                },
                elements:{
                    point:{
                        radius:0
                    }
                },
                maintainAspectRatio:false,
                tooltips:{
                    mode:"index",
                    intersect:false,
                    callback:{
                        label: function (tooltipItem,data){
                            return numeral(tooltipItem.value).format("+0.0")
                        },
                    },
                },

                scales:{
                    xAxes:[
                        {
                            type: "time",
                            time: {
                                format: "MM/DD/YY",
                                tooltipFormat: "ll"
                            }
                        }
                    ],yAxes: [
                        {
                            gridLines:{
                                display:false
                            },
                            ticks: {
                                callback: function(value, index, values) {
                                    return numeral(value).format("0a")
                                },
                            },                           
                        },
                    ]
                }
              }}/>
        </div>
    )
}

export default LineGraph
